import styles from './SearchTray.module.css';

/** 4-row CSS-pulse skeleton shown while debounced FTS is in-flight. */
export function SearchSkeleton() {
  return (
    <div role="status" aria-live="polite" aria-busy="true" aria-label="Loading search results">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className={styles.skeletonRow}>
          <div className={styles.skeletonIcon} />
          <div className={styles.skeletonText} style={{ maxWidth: `${60 + ((i * 13) % 35)}%` }} />
        </div>
      ))}
    </div>
  );
}
